import React, { useEffect, useState } from "react";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import ContactCard from "./ContactCard";
import FilterBar from "../common/Fiterbar";

import "./home.css";
import {
  CircularProgress,
  Divider,
  Stack,
  Pagination,
  Button,
} from "@mui/material";
import { Logout } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [contacts, setContacts] = useState([]);
  const [page, setPage] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [padination, setPagination] = useState({});
const navigate = useNavigate()
  const getContatcs = async () => {
    const id = localStorage.getItem("userId");
    const data = {
      url:
        apis().getContacts +
        `?type=${selectedFilter}&&search=${q}&&userId=${id}&&page=${page}`,
    };
    setLoading(true);
    const result = await httpAction(data);
    setLoading(false);
    if (result?.status) {
      setPagination(result?.pagination);
      setContacts(result?.contacts);
      setPage(result?.pagination?.currentPage)

    }
  };

  useEffect(() => {
    getContatcs();
  }, [q, selectedFilter, page]);

  const filterChnage = (value) => {
    setSelectedFilter(value);
  };
  const searchChnage = (event) => {
    const value = event.target.value;
    setQ(value);
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="user_home_header">
          <div className="home-filter-main">
            <Stack spacing={2}>
              <Button onClick={()=>{
                localStorage.removeItem('userId')
                navigate('/login')
                
              }} variant="outlined" size="small" endIcon={<Logout/>} >log out</Button>
              <FilterBar
                filterChange={filterChnage}
                searchChnage={searchChnage}
                selectedFilter={selectedFilter}
              />
              <Divider />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  // padding: "1rem 0",
                }}
              >
                <Pagination
                size="small"
              shape="rounded"
                  onChange={(event, value) => setPage(value)}
                  count={padination?.totalPages}
                  color="primary"
                />
                {/* <Button size="small" variant="contained" endIcon={<Logout />}>
            Log out
          </Button> */}
              </div>
            </Stack>
          </div>
        </div>
        <div className="row g-2 m-0 p-0">
          {loading ? (
            <div className="user_contact_loading">
              <span style={{ color: "gray", fontSize: "14px" }}>
                Loading...
              </span>
              <CircularProgress size={26} />
            </div>
          ) : (
            contacts?.map((item, index) => (
              <ContactCard
                getContacts={getContatcs}
                contacts={contacts}
                setContacts={setContacts}
                item={item}
                key={index}
              />
            ))
          )}
          {contacts.length === 0 && !loading && (
            <span className="user_contact_loading">No contact found</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
